import React, { useContext } from "react";
import { STYLE_DEFAULT_TAB_BED } from "App/constants";

import { TableCell, TableRow } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { headCells } from "./helpers";

import { TableWrapper } from "App/Component/ui";
import { defaultDateDisplay, isNull } from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";

const useStyles = STYLE_DEFAULT_TAB_BED;

export default function TabHistory() {
  const classes = useStyles();
  const { dataHistory } = useContext(FormContext);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: dataHistory,
    orderByDefault: "date",
    orderByRow: ["date"],
  });
  return (
    <div className={classes.root}>
      <TableWrapper
        title="Daftar History Fixed Asset"
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={dataHistory}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        withPadding={true}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>
                <TableCell align="left">{row?.nama_asset}</TableCell>
                <TableCell align="left">{row?.code}</TableCell>
                <TableCell align="left">
                  {isNull(row?.penerima) ? "-" : row?.penerima}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.gudang_sumber) ? "-" : row?.gudang_sumber}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.gudang_tujuan) ? "-" : row?.gudang_tujuan}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.date) ? "-" : defaultDateDisplay(row?.date)}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.remark) ? "-" : row?.remark}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.createdAt)}
                </TableCell>
                <TableCell align="left">
                  {row?.createdBy}
                </TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
